import React from "react";
import { ArrowRight, Clock, CheckCircle } from "lucide-react";
import welcomeImg from "../../assets/images/welcome-img.svg";
import ExtendedWarrantyScreenWrapper, { 
  ExtendedWarrantyHeader, 
  ExtendedWarrantyCard, 
  ExtendedWarrantyButton 
} from "./ExtendedWarrantyScreenWrapper";

const ExtendedWarrantyWelcomeScreen = ({ onComplete }) => {
  const steps = [
    {
      icon: <CheckCircle className="w-6 h-6 text-green-500" />,
      title: "Check your vehicle's eligibility",
      description: "See if your car qualifies for extended warranty",
    },
    {
      icon: <CheckCircle className="w-6 h-6 text-green-500" />,
      title: "Create your account",
      description: "Quick verification to get started",
    },
    {
      icon: <CheckCircle className="w-6 h-6 text-green-500" />,
      title: "Tell us about your needs",
      description: "Answer a few questions about your vehicle",
    },
    {
      icon: <CheckCircle className="w-6 h-6 text-green-500" />,
      title: "Get connected with leading providers",
      description: "We'll help you find the right coverage",
    },
  ];

  return (
    <ExtendedWarrantyScreenWrapper>
      <ExtendedWarrantyHeader
        title="Extended Warranty by Ownli"
        subtitle="Find the right extended warranty coverage for your vehicle in just a few minutes."
      >
        <img className="mx-auto mt-5" src={welcomeImg} alt="Welcome image" />
      </ExtendedWarrantyHeader>

      <ExtendedWarrantyCard variant="info">
        <div className="flex items-center gap-3">
          <Clock className="min-w-[25px] min-h-[25px] text-green" />
          <p className="text-base text-darkGrey">
            Takes less than 3 minutes to check eligibility
          </p>
        </div>
      </ExtendedWarrantyCard>

      <ExtendedWarrantyCard>
        <div>
          <h2 className="text-base font-bold mb-4">
            Here's what to expect:
          </h2>
          <div className="space-y-4">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start gap-3">
                <span className="mt-2 min-w-[10px] min-h-[10px] bg-darkGreen rounded-full"></span>
                <div>
                  <h3 className="font-base text-darkGrey">{step.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ExtendedWarrantyCard>

      <div className="space-y-3">
        <ExtendedWarrantyButton onClick={onComplete}>
          Check My Vehicle's Eligibility
          <ArrowRight className="w-4 h-4" />
        </ExtendedWarrantyButton>

        <div className="text-center text-sm text-gray-600">
          By continuing, you agree to Ownli's{" "}
          <a
            href="https://support.ownli.co/hc/en-us/articles/360011275958-Terms-of-Service"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 underline inline-flex items-center"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="https://support.ownli.co/hc/en-us/articles/360011276138-Ownli-Privacy-Policy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 underline inline-flex items-center"
          >
            Privacy Policy
          </a>
          .
        </div>
      </div>
    </ExtendedWarrantyScreenWrapper>
  );
};

export default ExtendedWarrantyWelcomeScreen;
